// extracted by mini-css-extract-plugin
module.exports = {"secondSeriesInApp":"SecondSeriesInApp_secondSeriesInApp__bTGf2"};